<template>
  <vs-card>
    <div class="vx-row pt-5 px-5">
      <div class="vx-col w-full md:w-1/4 px-8">
        <form method="POST" @submit.prevent="save_changes">
          <!-- Gurudwara Name -->
          <div class="vx-row mb-3">
            <vs-input
              icon-pack="feather"
              class="w-full"
              v-validate="'required|exclude_special_char'"
              v-model="form.name"
              label="Committee Name *"
              placeholder="Delhi Sikh Gurdwara Management Committee"
              name="Committee Name"
              id="Committee Name"
            />
            <span class="text-danger text-sm" v-show="errors.has('Committee Name')">{{ errors.first('Committee Name') }}</span>
          </div>

          <!-- Country -->
          <div class="vx-row mb-3">
            <label class="vs-input--label">Country *</label>
            <select-2
              class="w-full country-input"
              name="country"
              placeholder=" Select Country"
              :value="form.country"
              @input="(item) => (form.country = item && item.value)"
              autocomplete
              :ssr="true"
              :multiple="false"
              v-model="countryID"
              v-validate="'required'"
              action="common/getCountries"
              :viewRendered="false"
              :options="CountryList"
            />
            <span class="text-danger text-sm" v-show="errors.has('country')">{{ errors.first('country') }}</span>
          </div>

          <!-- State -->
          <div class="vx-row mb-3">
            <label class="vs-input--label">State *</label>
            <select-2
              class="w-full"
              name="State"
              placeholder="Select State"
              :value="form.state"
              @input="(item) => (form.state = item && item.value)"
              autocomplete
              :ssr="true"
              :multiple="false"
              v-model="stateID"
              v-validate="'required'"
              action="common/getStates"
              :options="StateList"
              :viewRendered="false"
              :params="{ country: form.country }"
            />
            <span class="text-danger text-sm" v-show="errors.has('State')">{{ errors.first('State') }}</span>
          </div>

          <!-- City -->
          <div class="vx-row mb-3">
            <label class="vs-input--label">City *</label>
            <select-2
              class="w-full"
              name="City"
              placeholder="Select City"
              :value="form.city"
              v-model="cityID"
              @input="(item) => (form.city = item && item.value)"
              :options="CityList"
              autocomplete
              :ssr="true"
              :viewRendered="false"
              :multiple="false"
              v-validate="'required'"
              action="common/getCities"
              :params="{ state: form.state, country: form.country }"
            />
            <span class="text-danger text-sm" v-show="errors.has('City')">{{ errors.first('City') }}</span>
          </div>

          <!-- Location Link -->
          <div class="vx-row mb-3">
            <vs-input
              icon="icon icon-map-pin"
              icon-pack="feather"
              class="w-full"
              v-validate="'required|exclude_special_char|url'"
              v-model="form.location_link"
              label="Location Link *"
              placeholder=" https://goo.gl/maps/2X1tD5XJ1xC2"
              name="Location Link"
              id="Location Link"
            />
            <span class="text-danger text-sm" v-show="errors.has('Location Link')">{{ errors.first('Location Link') }}</span>
          </div>

          <!-- Email -->
          <div class="vx-row mb-3">
            <vs-input
              label="Email *"
              placeholder="Email"
              class="w-full input"
              id="Email"
              v-validate="'required|email|min:4'"
              name="Email"
              icon="icon icon-mail"
              icon-pack="feather"
              v-model="form.email"
            />
            <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
          </div>

          <!-- Phone -->
          <div class="vx-row mb-3">
            <vs-input
              label="Phone *"
              placeholder="Phone"
              class="w-full input"
              id="Phone"
              v-validate="'required|exclude_special_char|min:4'"
              name="Phone"
              icon="icon icon-phone"
              icon-pack="feather"
              v-model="form.mobile_number"
            />
            <span class="text-danger text-sm" v-show="errors.has('Phone')">{{ errors.first('Phone') }}</span>
          </div>

          <!-- Committee Images -->
          <!-- <div class="vx-row mb-3">
            <label class="vs-input--label block">Images *</label>
            <input
              type="file"
              class="border p-2 rounded w-full"
              name="gurudwara_image"
              ref="files"
              accept=".jpg, .png , .jpeg"
              @change="handleFileUpload"
              style="border: 1px solid rgba(0, 0, 0, 0.2)"
              multiple
            />
            <span class="text-danger text-sm" v-show="errors.has('gurudwara_image')">{{ errors.first('gurudwara_image') }}</span>
          </div>
          <div class="vx-col w-1/2 mb-2"></div>
          <div class="vx-col w-full">
            <div class="mt-5 grid grid-cols-8 gap-4">
              <div v-for="(image, index) in form.exist_gurudwara_image" :key="index" class="relative group h-48 w-48">
                <div class="overflow-hidden mb-2">
                  <img :src="image" alt="Image Preview" class="h-48 w-48" />
                  <div class="absolute top-0 right-0">
                    <vx-tooltip :text="`Remove`" class="cursor-pointer">
                      <div class="text-xl w-8 h-8 flex justify-center items-center bg-grey text-white rounded" @click="removeFile(image, 'edit')">&#x2715;</div>
                    </vx-tooltip>
                  </div>
                </div>
              </div>
              <div v-for="(image, index) in preview_images" class="relative group h-48 w-48">
                <div class="overflow-hidden mb-2">
                  <img :src="image.src" alt="Image Preview" class="h-48 w-48" />
                  <div class="absolute top-0 right-0">
                    <vx-tooltip :text="`Remove`" class="cursor-pointer">
                      <div class="text-xl w-8 h-8 flex justify-center items-center bg-grey text-white rounded" @click="removeFile(index, 'preview')">&#x2715;</div>
                    </vx-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>            -->

          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex flex-wrap items-center justify-start">
                <vs-button class="mr-2 vs-con-loading__container" id="create-committee" @click="save_changes">{{ $route.params.id ? 'Update' : 'Add' }}</vs-button>
                <vs-button @click="navigateToList" color="danger" class="text-white-500">Cancel</vs-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <vs-popup title="Image Cropper" name="Image" :active.sync="IsOpenImageCrop" class="image-cropper" style="z-index: 55000">
      <div class="text-center flex justify-center w-full h-full">
        <!-- modal content -->
        <div class="modal__content w-full h-full">
          <!-- modal body -->
          <div class="modal-body w-full h-full">
            <div class="modal-form w-full h-full">
              <div v-for="(cropImage, index) in this.crop_image" class="cropper-container">
                <div class="w-full h-full max-h-450 py-5">
                  <cropper ref="cropper" :name="'Image' + index" class="cropper-image" :src="cropImage.src" :stencil-props="{ aspectRatio: 12 / 12 }" />
                </div>
              </div>
              <div class="button-wrapper mt-3">
                <vs-button type="" @click="cropImage()" class="text-primary border border-solid border-primary">Crop Image</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </vs-card>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { mapActions, mapState } from 'vuex'

export default {
  /** Page Name */
  name: 'AddUpdate',

  /** components */
  components: {
    Select2,
    Cropper
  },

  /** data */
  data() {
    return {
      breadcrumb: [],
      countryID: null,
      stateID: null,
      cityID: null,
      StateList: [],
      CountryList: [],
      CityList: [],
      form: {
        name: null,
        location_link: null,
        country: null,
        state: null,
        city: null,
        mobile_number: null,
        email: null
      },
      preview_images: [],
      crop_image: [],
      IsOpenImageCrop: false
    }
  },

  /** computed */
  computed: {
    ...mapState('committee', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    }
  },

  /** created */
  async created() {
    if (this.$route.params.id) {
      await this.$store.dispatch('committee/show', this.$route.params.id).then(async (res) => {
        const data = res.data.data

        /** breadcrumb implement  */
        this.breadcrumb = [
          { title: 'Dashboard', url: '/dashboard' },
          { title: 'Committee', url: '/committee/list' },
          { title: `Edit ${data.name}`, active: true }
        ]

        this.form.country = this.countryID = data.country._id
        this.cityID = data.city._id
        this.initial_country = data.country
        this.initial_state = data.state
        /* form variable */
        this.form.name = data.name
        this.form.mobile_number = data.mobile_number
        this.form.email = data.email
        this.form.location_link = data.location_link

        const companyResult = await this.getCountries({ page: 1, limit: 300000, type: 'dropdown', country_id: data.country._id })
        this.CountryList = companyResult.data

        if (data.country._id) {
          const stateResult = await this.getStates({ country: data.country._id, page: 1, limit: 300000, type: 'dropdown', state_id: data.state._id })
          this.StateList = stateResult.data
          this.stateID = this.form.state = data.state._id
        }

        if (data.state._id) {
          const cityResult = await this.getCities({ state: data.state._id, country: data.country._id, page: 1, limit: 300000, type: 'dropdown', city_id: data.city._id })
          this.CityList = cityResult.data
          this.cityID = this.form.city = data.city._id
        }
      })
    } else {
      const companyResult = await this.getCountries({ page: 1, limit: 300000, type: 'dropdown' })
      this.CountryList = companyResult.data
    }

    const { best_time_to_visit, best_weather_to_visit } = await this.getPreDefinedValues()
    this.BEST_TIME_TO_VISIT_LIST = best_time_to_visit.map((value) => {
      return {
        value,
        label: value
      }
    })
    this.BEST_WEATHR_TO_VISIT_LIST = best_weather_to_visit.map((value) => {
      return {
        value,
        label: value
      }
    })
  },

  /** methods */
  methods: {
    ...mapActions('committee', {
      create: 'create',
      update: 'update'
    }),
    ...mapActions('common', {
      getCountries: 'getCountries',
      getStates: 'getStates',
      getCities: 'getCities',
      getPreDefinedValues: 'getPreDefinedValues'
    }),
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        let response
        const data = new FormData()
        for (const key in this.form) {
          if (typeof this.form[key] === 'object') {
            if (key == 'sarai') {
              this.form[key].map((item, index) => {
                for (const field in item) {
                  if (field == 'mobile_number') {
                    item[field].map((v, i) => {
                      data.append(`${key}[${index}][${field}][]`, v)
                    })
                  } else {
                    data.append(`${key}[${index}][${field}]`, item[field])
                  }
                }
              })
            } else if (this.form[key]) {
              this.form[key].map((item) => {
                data.append(key == 'gurudwara_image' ? key : `${key  }[]`, item)
              })
            }
          } else {
            data.append(key, this.form[key])
          }
        }
        if (this.$route.params.id) {
          response = await this.update({
            id: this.$route.params.id,
            data
          })
        } else {
          response = await this.create(data)
        }
        this.$router.push({
          name: 'committee-list'
        })
        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    async fetchStates() {
      const stateResult = await this.getStates({ country: this.countryID.value, page: 1, limit: 300000, type: 'dropdown' })
      this.StateList = stateResult.data
    },
    async fetchCities() {
      const cityResult = await this.getCities({ state: this.stateID.value, country: this.countryID.value, page: 1, limit: 300000, type: 'dropdown' })
      this.CityList = cityResult.data
    },

    /** add data in array */
    addData(type) {
      switch (type) {
      case 'other_name':
        this.form.other_name.push('')
        break
      case 'sarai':
        this.form.sarai.push({
          name: '',
          email: '',
          website: '',
          location: '',
          mobile_number: []
        })
        break
      case 'youtube_handle_name':
        this.form.youtube_handle_name.push('')
        break
      default:
        break
      }
    },

    /** remove data from array */
    removeData(type, index) {
      switch (type) {
      case 'other_name':
        this.form.other_name.splice(index, 1)
        break
      case 'sarai':
        this.form.sarai.splice(index, 1)
        break
      case 'youtube_handle_name':
        this.form.youtube_handle_name.splice(index, 1)
        break
      default:
        break
      }
    },

    /** add mobile number for sarai */
    addMobileNumber(saraiIndex) {
      this.form.sarai[saraiIndex].mobile_number.push('')
    },

    /** remove mobile number for sarai */
    removeMobileNumber(saraiIndex, mobileIndex) {
      this.form.sarai[saraiIndex].mobile_number.splice(mobileIndex, 1)
    },

    /** navigate to List */
    navigateToList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.$router.push({ name: 'committee-list' })
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },

    /** file upload  */
    handleFileUpload(e) {
      const files = Array.from(e.target.files) // Convert FileList to array
      this.crop_image = [] // user don't crop image and upload cancel to cropper Empty

      // Validate and handle each file
      files.forEach((file) => {
        if (!file) {
          this.$vs.notify({
            title: 'Error',
            text: 'No file selected',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
          return
        }
        // Create a preview URL and add it to the array
        // const previewURL = URL.createObjectURL(file);
        // this.preview_images.push({ src: previewURL, file });
        // this.form.gurudwara_image.push(file);

        const blob = URL.createObjectURL(file)

        this.crop_image.push({
          src: blob,
          type: file.type
        })
        // e.target.value = ''
        this.IsOpenImageCrop = true
      })
    },
    cropImage() {
      this.$refs.cropper.forEach((element, key) => {
        const result = element.getResult()
        if (result.canvas == undefined) {
          this.$vs.notify({
            title: 'Error',
            text: 'Please Select Image',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
          return
        }

        const resultTest = result.canvas.toDataURL(this.crop_image[key].type)

        const base64Image = resultTest.replace(`data:${this.crop_image[key].type};base64,`, '')

        this.b64toBlob(base64Image, this.crop_image[key].type, key)
      })
      this.crop_image = []
      this.IsOpenImageCrop = false
    },
    b64toBlob(b64Data, contentType = '', key, sliceSize = 512) {
      const byteCharacters = window.atob(b64Data)
      const byteArrays = []
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }

      const blob = new File(byteArrays, `image_${key}.jpg`, {
        type: contentType
      })
      // this.form.image = blob;
      // this.preview_image = URL.createObjectURL(blob);

      // this.form.gurudwara_image.push(file);

      this.preview_images.push({ src: URL.createObjectURL(blob), blob })
      this.form.gurudwara_image.push(blob)

      return blob
    },

    /** remove file */
    removeFile(index, type) {
      if (type == 'preview') {
        // Revoke the object URL
        URL.revokeObjectURL(this.preview_images[index].src)

        // Remove the file from the arrays
        this.preview_images.splice(index, 1)
        this.form.gurudwara_image.splice(index, 1)
      } else {
        const exist_index = this.form.exist_gurudwara_image.findIndex((value) => index == value)
        if (exist_index != -1) {
          this.form.exist_gurudwara_image.splice(exist_index, 1)
        }
      }
    }
  },

  /** watch */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-committee',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-committee > .con-vs-loading')
      }
    },
    countryID(newValue) {
      this.StateList = []
      this.form.state = null
      this.stateID = null
      if (newValue && newValue.value) {
        this.fetchStates()
      }
    },
    stateID(newValue, oldValue) {
      this.CityList = []
      this.form.city = null
      this.cityID = null
      if (newValue && newValue.value) {
        this.fetchCities()
      }
    }
  }
}
</script>

<style>
.cropper-image {
  height: 400px;
  background: #ddd;
}

.color {
  background-image: none !important;
}
</style>
